import { useApi } from '@/api';
import { KpiSkeleton, Flex, KpiCard } from '@blockanalitica/ui';

type BadDebtKpisResponse = {
  bad_debt: number;
  bad_debt_change: number;
  num_of_wallets: number;
  num_of_wallets_change: number;
  bad_debt_change_percentage: number;
  num_of_wallets_change_percentage: number;
};

export default function BadDebtKpis() {
  const [data, error] = useApi<BadDebtKpisResponse>({
    url: `/wallets/bad-debt-stats/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }
  return (
    <Flex flexDirection={['column', 'row']} gap={['m', 's']}>
      <KpiCard
        title="Total bad debt"
        data={data}
        field="bad_debt"
        options={{
          currency: 'USD',
          trend: true
        }}
      />
      <KpiCard
        title="N° of bad debt wallets"
        data={data}
        field="num_of_wallets"
      />
    </Flex>
  );
}
